import React from 'react';
import {
  Button,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { isImage } from './';

export const DocumentButtons = (props) => {
  return (
    <React.Fragment>
      {
        props.url &&
          <Button
            icon="magnify"
            size={props.size}
            onClick={() => props.onPreviewClick(props.url)}
            basic
          />
      }
      {
        props.url &&
          <Button
            as="a"
            href={props.url}
            basic
            icon="download"
            size={props.size}
            primary
            download={props.filename}
          />
      }
      {
        props.url && !props.accepted &&
          <Button
            icon="trash"
            basic
            negative
            size={props.size}
            onClick={props.onDeleteClick}
          />
      }
    </React.Fragment>
  );
}

DocumentButtons.defaultProps = {
  size: 'large',
};

DocumentButtons.propTypes = {
  accepted: PropTypes.bool,
  display: PropTypes.bool,
  id: PropTypes.number,
  filename: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.string,
  url: PropTypes.string,
}
